import { NgModule } from '@angular/core';

import { MasterCreateUserActions } from './master-create-user.actions';

@NgModule({
  providers: [
    MasterCreateUserActions
  ]
})
export class MasterCreateUserActionsModule {}
